/**
 * @createDate 2022年11月10日
 * @name 导出文件名称
 * @params 请求参数
 * @type 请求类型
 */
export default (fileName, params = '', type = 'GET') => {
	return new Promise((resolve, reject) => {
		const url = this.$env.VUE_APP_BASE_DOWNLOAD_URL
		type = type.toUpperCase();
		let xhr = new XMLHttpRequest();
		if (type === 'POST') {
			let data = params ? JSON.stringify(params) : {};
			xhr.open('POST', url, true);
			xhr.responseType = 'blob';
			xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
			xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'));
			xhr.send(data);
			xhr.onload = function() {
				if (this.status === 200) {
					let blob = this.response;
					let a = document.createElement('a');
					let aUrl = window.URL.createObjectURL(blob);
					a.href = aUrl;
					a.download = fileName;
					a.click();
					a.remove()
				}
			};
			resolve(xhr)
		} else {
			let newUrl = url;
			if (params) {
				let getParams = '?';
				for (let key in params) {
					if (params[key]) {
						getParams += `${key}=${params[key]}&`
					}
				}
				newUrl + url + getParams
			}
			xhr.open('GET', newUrl, true);
			xhr.responseType = 'blob';
			xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
			xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'));
			xhr.send();
			xhr.onload = function() {
				if (this.status === 200) {
					let blob = this.response;
					let a = document.createElement('a');
					let aUrl = window.URL.createObjectURL(blob);
					a.href = aUrl;
					a.download = fileName;
					a.click();
					a.remove();
				}
			};
			resolve(xhr)
		}
	})
};
